import { SynthFilterId } from './types';

/**
 * Ordered filter ids each test-results tab renders. Adding a filter to a tab is a
 * one-line change here. Empty arrays mean the tab renders no filters (ready to extend).
 */
export const TAB_FILTERS: Record<string, SynthFilterId[]> = {
  metrics: ['sourceAgent', 'target', 'site', 'asn', 'label'],
  path: ['sourceAgent', 'target'],
  agents: [],
  map: []
};
